<script setup>
import {computed,defineEmits,defineProps, ref} from "vue";
import {game} from "@/utils/config";

const type = computed(() => game.qxdj)
const props = defineProps({
  product: {
    type: Object,
    default() {
      return {}
    }
  },
  changeProduct: {
    type: Boolean,
    default() {
      return false
    }
  },
  account: {
    type: Object,
    default() {
      return {}
    }
  },
  payLoading: {
    type: Boolean,
    default: () => {
      return false
    }
  }
})
const rechargeAccount = ref('')
const changeProduct = computed(() => props.changeProduct)
const emit = defineEmits(['pay'])
</script>

<template>
  <el-drawer v-model="changeProduct" direction="btt" style="border-radius: 12px 12px 0 0" size="420"
             :show-close="false" v-if="changeProduct" :style="type.style">
    <template #header>
      <div class="product-info-header">
        <div class="product-info-img">
          <el-image :src="type.productImgAvatar"/>
        </div>
        <div class="product-info-data">
          <h4 v-if="props.product?.plate === '优惠券'">{{ type.name }}{{ parseInt(props.product.face_value) }}元{{ type.coupon_type }}</h4>
          <h4 v-else>{{ product?.goods_name }}</h4>
          <div class="product-info-money">
            <b>{{ props.product?.mileTypes?.scal?.total }}</b>里程
          </div>
        </div>
      </div>
    </template>
    <el-card style="margin-bottom: 20px">
      <div class="user-account-data">
        <div class="user-account-data-title">
          {{ type.input_tag }}
        </div>
        <div class="input">
          <div class="tips">{{ type.tips }}</div>
          <el-input :placeholder="type.placeholder" clearable class="product-input"
                    v-model="rechargeAccount"/>
        </div>
      </div>
    </el-card>
    <el-card style="margin-bottom: 20px">
      <div class="user-account-miles">
        <div class="user-account-data-jingle">
          可用里程
        </div>
        <div class="miles">
          {{ props.account.balance_miles }}
        </div>
      </div>
      <div class="user-account-miles">
        <div class="user-account-data-jingle">
          支付里程
        </div>
        <div class="miles">
          {{ props.product?.mileTypes?.scal?.total }}
        </div>
      </div>
    </el-card>
    <div class="product-recharge-btn">
      <el-button type="danger" round size="large"
                 :disabled="parseInt(props.product?.mileTypes?.scal?.total) > props.account?.balance_miles || !type.isIos"
                 :loading="props.payLoading"
                 @click="emit('pay',{account:rechargeAccount,number:1})">立即兑换
      </el-button>
    </div>
  </el-drawer>
</template>

<style scoped lang="less">
.product-info-header {
  display: flex;
  align-items: center;

  .product-info-img {
    width: 80px;
    padding: 10px;
    text-align: center;
    margin-right: 5px;
    background: var(--view-background-color);
    border-radius: 8px;

    .el-image {
      width: 65%;
    }
  }

  .product-info-data {
    margin-left: 10px;
    line-height: 25px;

    .product-info-money {
      margin-top: 10px;

      b {
        font-size: 1.75rem;
        color: #E31D1A;
      }
    }
  }
}

.user-account-data {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .tips {
    font-size: .65rem;
    color: #FF8409;
    white-space: nowrap;
    text-align: left;
  }

  .user-account-data-title {
    font-size: .8rem;
    color: var(--view-product-user-pay-account-tips);
    border: var(--view-product-user-pay-account-tips-border);
    padding: 5px;
    border-radius: 3px;
  }

  .input {
    width: 72%;
    flex-basis: 72%;
  }
}

.user-account-miles {
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 35px;

  & + .user-account-miles {
    border-top: var(--el-border);
  }
}

.product-recharge-btn {
  width: 220px;
  margin: auto;

  .el-button {
    width: 100%;

  }
}
</style>
